import { TPromoAditionalCallback } from '~/src/features/specialOffersContainer/types';

export const isCallbackDefined = (callback?: TPromoAditionalCallback): callback is TPromoAditionalCallback => !!callback;
